var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconShare20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 1.144,
  d: "M11.984 14.81a2.508 2.508 0 0 0 3.62 3.27 2.508 2.508 0 0 0-2.275-4.43 2.5 2.5 0 0 0-1.345 1.16Zm0 0-5.27-3.763m0 0a2.507 2.507 0 1 1 0-2.396m0 2.396a2.52 2.52 0 0 0 0-2.396m0 0 5.27-3.765m0 0a2.508 2.508 0 1 1 4.408-2.394 2.508 2.508 0 0 1-4.408 2.394Z"
})));
export default SvgIconShare20;